<template>
  <v-container fluid>
    <v-row>
      <div class="inside" v-if="modules.Illumination">
        <v-col cols="12">
          <div class="d-flex justify-center">
            <v-subheader class="display-1 font-weight-bold has-border"
              >Illumination</v-subheader
            >
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3">
          <data-card
            subIcon="mdi-calendar"
            subtitle="Till Today's Date"
            icon="mdi-school"
            color="accent"
            title="Total Franchisee"
            :value="data.franchiseeCount"
          ></data-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <data-card
            subIcon="mdi-calendar"
            subtitle="Till Today's Date"
            icon="mdi-human-child"
            color="warning"
            title="Total Students"
            :value="data.studentAdmissionsCount"
          ></data-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <data-card
            icon="mdi-file-document"
            color="info"
            title="Total Enquiries"
            :value="data.enquiriesCount"
            :smallValue="
              data && data.enquiriesCountForToday
                ? data.enquiriesCountForToday
                : '0'
            "
            subtitle="Today's Enquiry"
          ></data-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <data-card
            subIcon="mdi-calendar"
            subtitle="Till Today's Date"
            icon="mdi-cart"
            color="pink"
            title="Total Order"
            :value="data.ordersCount"
          >
          </data-card>
        </v-col>
      </div>
      <div class="inside">
        <v-col cols="12">
          <v-row v-if="modules.TicketAdmin">
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <div class="d-flex justify-center">
                    <v-subheader class="display-1 font-weight-bold has-border"
                      >Ticket Illumination
                    </v-subheader>
                  </div>
                </v-col>
                <v-col cols="12" md="2"></v-col>
                <v-col cols="12" sm="6" md="4">

                  <router-link
                    :to="{
                      name: 'beesTicketList',
                      params: {
                        ticketstatus: 'open',
                        franchiseeID: franchiseeID
                      }
                    }"
                    title="FC Open"
                  >
                    <clickable-card
                      goIcon="mdi-arrow-top-right"
                      icon="mdi-email-mark-as-unread"
                      color="error"
                      title="Open Ticket"
                      :value="ticketCount.openTickets"
                    >
                    </clickable-card>
                  </router-link>
                </v-col>
                <v-col cols="12" sm="6" md="4">

                  <router-link
                    :to="{
                      name: 'beesTicketList',
                      params: {
                        ticketstatus: 'closed',
                        franchiseeID: franchiseeID
                      }
                    }"
                    title="FC Close"
                  >
                    <clickable-card
                      goIcon="mdi-arrow-top-right"
                      icon="mdi-email-check"
                      color="success"
                      title="Closed Ticket"
                      :value="ticketCount.closedTicketsToday"
                    >
                    </clickable-card>
                  </router-link>
                </v-col>
                <v-col cols="12" md="2"></v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </div>
      <div class="inside" v-if="modules.StaffCount && staffCount">
        <v-col cols="12">
          <div class="d-flex justify-center">
            <v-subheader class="display-1 font-weight-bold has-border"
              >Staff Count</v-subheader
            >
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <data-card
            subIcon="mdi-calendar"
            subtitle="Till Today's Date"
            icon="mdi-school"
            color="accent"
            title="Teaching Staff"
            :value="staffCount.teachingStaff"
          ></data-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <data-card
            subIcon="mdi-calendar"
            subtitle="Till Today's Date"
            icon="mdi-account-multiple"
            color="warning"
            title="Non-teaching Staff"
            :value="staffCount.nonTeachingStaff"
          ></data-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <data-card
            subIcon="mdi-calendar"
            subtitle="Till Today's Date"
            icon="mdi-account-group"
            color="pink"
            title="Total Staff"
            :value="staffCount.totalStaff"
          >
          </data-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="4">
          <data-card
            subIcon="mdi-calendar"
            subtitle="Till Today's Date"
            icon="mdi-account-tie"
            color="accent"
            title="Training Staff"
            :value="staffCount.trainingStaff"
          ></data-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <data-card
            subIcon="mdi-calendar"
            subtitle="Till Today's Date"
            icon="mdi-account-alert"
            color="warning"
            title="Non-training Staff"
            :value="staffCount.nonTrainingStaff"
          ></data-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <data-card
            subIcon="mdi-calendar"
            subtitle="Till Today's Date"
            icon="mdi-account-supervisor-circle-outline"
            color="pink"
            title="Total Staff"
            :value="staffCount.totalStaff"
          >
          </data-card>
        </v-col>
      </div>

      <div class="inside">
        <v-col cols="12" v-if="modules.Royalty && kitRoyaltyData.length > 0">
          <material-card
            icon="mdi-cash-multiple"
            class="mt-7"
            title="Royalty Details Chart"
          >
            <div class="vertical-divider hidden-sm-and-down pl-1"></div>
            <apexchart
              type="bar"
              :options="chartOptions"
              :series="series"
              xaxis
            >
            </apexchart>
          </material-card>
        </v-col>

        <v-col cols="12" v-if="modules.Order && kitSalesData.length > 0">
          <material-card icon="mdi-cart-arrow-down" title="Order Details Chart">
            <apexchart type="bar" :options="chartOptions2" :series="series2">
            </apexchart>
          </material-card>
        </v-col>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import Utils from '@/utils'
import constants from '@/utils/constants'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import MaterialCard from '@/components/template/MaterialCard'
import DataCard from '@/components/template/DataCard'
import ClickableCard from '@/components/template/ClickableCard'
export default {
  components: { MaterialCard, DataCard, ClickableCard },
  name: 'Dashboard',
  data () {
    return {
      KIT: constants.KIT,
      modules: {
        Illumination: this.checkModuleAccess('Illumination'),
        FranchiseeSelect: this.checkModuleAccess('FranchiseeSelect'),
        Royalty: this.checkModuleAccess('Royalty'),
        Order: this.checkModuleAccess('Order'),
        TicketAdmin: this.checkModuleAccess('TicketAdmin'),
        AcademicYearSelect: this.checkModuleAccess('AcademicYearSelect'),
        StaffCount: this.checkModuleAccess('StaffCount')
      },
      stdData: [],
      staffCount: null,
      total: 0,
      data: [],
      flag: false,
      academicYearID: '',
      franchiseeID: '',
      academicYears: [],
      franchiseeArr: [],
      ticketCount: [],
      installmentName: [],
      count: [],
      paid: [],
      dues: [],
      cancelled: [],
      confirmed: [],
      kitCount: [],
      delivered: [],
      fail: [],
      kitType: [],
      pending: [],
      shipped: [],
      subscriptionMonth: [],
      inProgress: false,
      kitRoyaltyData: [],
      kitSalesData: [],
      isLoading: false
    }
  },

  mounted: async function () {
    this.$dialog.message.info('Welcome to Intellitots', {
      position: 'bottom-right',
      color: 'secondary',
      timeout: 4000
    })
    await this.onFranchiseeChange()
  },
  created: async function () {
    // await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },

  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    }),
    series: function () {
      return [
        // {
        //   name: 'Total Count',
        //   data: this.count
        // },
        {
          name: 'Paid',
          data: this.paid
        },
        {
          name: 'Dues',
          data: this.dues
        }
      ]
    },

    chartOptions: function () {
      return {
        colors: ['#4caf50', '#f0aa00', '#1976D2', '#00cae3'],
        chart: {
          type: 'bar',
          height: 400,
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          },
          animations: {
            enabled: false
          }
        },
        noData: {
          text: 'Loading....'
        },
        markers: {
          size: 0
        },
        dataLabels: {
          enabled: true
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        responsive: [
          {
            options: {
              legend: {
                position: 'bottom',
                offsetX: 0,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        xaxis: {
          categories: this.installmentName
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'top',
          offsetX: 0,
          offsetY: 0
        }
      }
    },
    series2: function () {
      return [
        // {
        //   name: 'Total Count',
        //   data: this.kitCount
        // },

        {
          name: 'Shipped',
          data: this.shipped
        },
        {
          name: 'Pending',
          data: this.pending
        },
        {
          name: 'Confirmed',
          data: this.confirmed
        },
        {
          name: 'Delivered',
          data: this.delivered
        },
        {
          name: 'Failed',
          data: this.fail
        },
        {
          name: 'Cancelled',
          data: this.cancelled
        }
      ]
    },

    chartOptions2: function () {
      return {
        colors: [
          '#9C27b0',
          '#f0aa00',
          '#1976D2',
          '#4caf50',
          '#ff5252',
          '#424242'
        ],
        chart: {
          type: 'bar',
          height: 400,
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          },
          animations: {
            enabled: false
          }
        },
        markers: {
          size: 0
        },
        dataLabels: {
          enabled: true
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        noData: {
          text: 'Loading....'
        },
        responsive: [
          {
            options: {
              legend: {
                position: 'bottom',
                offsetX: 0,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        xaxis: {
          categories: this.kitType
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'top',
          offsetX: 0,
          offsetY: 0
        }
      }
    }
  },

  methods: {
    onFranchiseeChange: async function () {
      this.staffCount = null
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ' '
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.staffCount = null
        await this.royaltyCount()
        await this.totalCount()
        await this.getStaffData()

        // await this.getStudentData()
        this.inProgress = false
      }
    },

    getChartData: function (data) {
      if (this.modules.Royalty || this.modules.Order) {
        this.data = data
        this.kitSalesData = _.orderBy(data.orderByKitCount, [
          ['kitType'],
          ['ASC']
        ])
        // console.log(this.kitSalesData, 'this.kitSalesData')
        this.cancelled = _.map(this.kitSalesData, 'cancelled')
        this.confirmed = _.map(this.kitSalesData, 'confirmed')
        this.kitCount = _.map(this.kitSalesData, 'count')
        this.pending = _.map(this.kitSalesData, 'pending')
        this.delivered = _.map(this.kitSalesData, 'delivered')
        this.fail = _.map(this.kitSalesData, 'fail')
        this.kitType = _.map(this.kitSalesData, 'kitType')
        this.shipped = _.map(this.kitSalesData, 'shipped')
        this.subscriptionMonth = _.map(this.kitSalesData, 'subscriptionMonth')
      }
      this.kitType.map((e, i) => {
        this.KIT.forEach((el, j) => {
          if (el.id === e) {
            this.kitType[i] = el.name
          }
        })
      })
      this.kitType.map((e, i) => {
        this.subscriptionMonth.forEach((el, j) => {
          if (e === 'INTELLI KIT' && i === j) {
            this.kitType[i] = e + ' ' + (el + 1)
          }
        })
      })
      this.kitCount.forEach((e, i) => {
        if (e.toString().length === 1) {
          this.kitCount[i] = `${'[00' + e + ']'}`
        } else if (e.toString().length === 2) {
          this.kitCount[i] = `${'[0' + e + ']'}`
        } else {
          this.kitCount[i] = e
        }
      })
      this.kitType.map((e, i) => {
        this.kitCount.forEach((el, j) => {
          if (i === j) {
            this.kitType[i] = `${this.kitCount[j]}` + ' ' + e
          }
        })
      })
    },

    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    getKitName: function (kitType) {
      let kitName = _.find(constants.KIT, (item) => _.isEqual(item.id, kitType))
      return kitName ? kitName.name : kitType
    },
    showOrderWise: function () {
      return (this.flag = !this.flag)
    },
    totalCount: async function () {
      if (this.modules.TicketAdmin) {
        await this.getTickeingUserData()
      }
      if (
        this.modules.Illumination ||
        this.modules.Royalty ||
        this.modules.Order
      ) {
        try {
          const { data } = await http.get(
            `${constants.API_URL}/api/get-all-count?franchiseeID=${this.franchiseeID}&academicYearID=${this.academicYearID}`
          )
          this.data = data
          this.getChartData(data)
          this.data.orderByKitCount.forEach((Obj) => {
            Obj.kitType = this.getKitName(Obj.kitType)
          })
        } catch (e) {
          this.enableFilterModal = false
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          return this.$dialog.error({
            text: errorMessage,
            title: 'Error'
          })
        } finally {
        }
      }
    },
    royaltyCount: async function () {
      if (this.modules.Royalty) {
        try {
          const { data } = await http.get(
            `${constants.API_URL}/api/get-royalty-count?franchiseeID=${this.franchiseeID}&academicYearID=${this.academicYearID}`
          )
          if (data) {
            this.data = data.amountRoyaltyData
            this.kitRoyaltyData = _.orderBy(data.amountRoyaltyData, [
              ['name'],
              ['ASC']
            ])
            this.count = _.map(this.kitRoyaltyData, 'count')
            this.paid = _.map(this.kitRoyaltyData, 'paid')
            this.dues = _.map(this.kitRoyaltyData, 'dues')
            let installmentName = _.map(this.kitRoyaltyData, 'name')

            this.count.forEach((e, i) => {
              if (e.toString().length === 1) {
                this.count[i] = `${'[00' + e + ']'}`
              } else if (e.toString().length === 2) {
                this.count[i] = `${'[0' + e + ']'}`
              } else {
                this.count[i] = e
              }
            })

            installmentName.map((e, i) => {
              installmentName[i] = e.replace(/\s+/g, ' ').trim()
              this.count.forEach((el, j) => {
                if (i === j) {
                  installmentName[i] = `${this.count[j]}` + ' ' + e
                }
              })
            })

            this.installmentName = installmentName
          }
          // .sort(collator.compare)
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          return this.$dialog.error({
            text: errorMessage,
            title: 'Error'
          })
        } finally {
        }
      }
    },

    getStaffData: async function () {
      if (this.modules.StaffCount) {
        let url = this.franchiseeID
          ? `${constants.API_URL}/api/staff/teacher/count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}`
          : `${constants.API_URL}/api/staff/teacher/count`
        try {
          let res = await http.get(url)
          this.staffCount = res.data
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          console.log(errorMessage)
        } finally {
        }
      }
    },
    // getStudentData: async function () {
    //   if (!this.franchiseeID) {
    //     this.errMsg('Kindly select franchisee!')
    //     return false
    //   } else if (!this.academicYearID) {
    //     this.errMsg('Kindly select academic year!')
    //     return false
    //   }
    //   if (this.franchiseeID && this.academicYearID) {
    //     try {
    //       this. = true
    //       const { data } = await http.get(`${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&academicYearID=${this.academicYearID}&isAllValue=false`)
    //       this.stdData = data
    //       console.table(this.stdData)
    //     } catch {}
    //   }
    // },
    getTickeingUserData: async function () {
      try {
        const TicketingAdminResponse = await http.get(
          `${constants.API_URL}/api/sbTicketing/stats${
            this.franchiseeID ? '?franchiseeID=' + this.franchiseeID : ''
          }`
        )
        this.ticketCount = TicketingAdminResponse.data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
